<template>
    <div id="login" ref="login">
        <picture>
            <source :srcset="$url + 'img/bg_acesso.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_acesso.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_acesso.webp'">
        </picture>
        <ul>
            <li><img :src="$url + 'img/logo.png'"></li>
            <li><h4>CONTRA A DENGUE E PELA PRESERVAÇÃO DA ÁGUA</h4></li>
            <li>
                <ul>
                    <li>
                        <transition name="fade">
                            <form v-if="show" class="box-0" id="login-form" method="post" ref="login-form" v-on:submit="login">
                                <h3>Login</h3>
                                <ul>
                                    <li>
                                        <input id="name" name="name" placeholder="Nome de usuário" ref="name" required type="text">
                                    </li>
                                    <li>
                                        <input id="password" name="password" placeholder="Senha" ref="password" required type="password">
                                        <img alt="Icon eye" class="icon-eye" v-on:click="passwordHandler" :src="$url + '/img/' + password_icon">
                                    </li>
                                    <li>
                                        <div v-if="errors" id="errors">
                                            <div v-for="(o, key) in errors" v-bind:key="key">
                                                <span class="error" v-for="(i, k) in o" v-bind:key="k" v-html="i"></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div v-if="error" id="error">{{ error }}</div>
                                        <input ref="btn-submit" type="submit" :value="btn_submit_value">
                                    </li>
                                </ul>
                            </form>
                        </transition>
                    </li>
                    <li>
                        <transition name="fade">
                            <form v-if="show" id="register-form" method="post" ref="register-form" v-on:submit="register">
                                <h3 style="color:#227048">Cadastre-se</h3>
                                <ul>
                                    <li>
                                        <input id="name_register" name="name_register" placeholder="Nome de usuário" ref="name_register" required type="text">
                                    </li>
                                    <li>
                                        <input id="email" name="email" placeholder="E-mail(Opcional)" ref="email" type="email">
                                    </li>
                                    <li>
                                        <input id="password_register" name="password_register" placeholder="Senha" ref="password_register" required type="password">
                                        <img alt="Icon eye" class="icon-eye" v-on:click="passwordHandler" :src="$url + '/img/' + password_icon">
                                    </li>
                                    <li>
                                        <div v-if="errors_register" id="errors">
                                            <div v-for="(o, key) in errors_register" v-bind:key="key">
                                                <span class="error" v-for="(i, k) in o" v-bind:key="k" v-html="i"></span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style="background-color: white; margin: 10px; padding: 20px;">
                                        <div class="checkbox-container">
                                            <input class="styled-checkbox" id="terms" name="terms" ref="terms" type="checkbox" value="1" required>
                                            <label class="form-check-label" for="terms">Aceito os <a href="#" v-on:click="$parent.view_terms=true" style="display: inline;text-decoration:underline">termos de privacidade</a></label>
                                        </div>
                                        
                                    </li>
                                    <li>
                                        <div v-if="error_register" id="error">{{ error_register }}</div>
                                        <input ref="btn-submit" style="background-color:#227048" type="submit" :value="btn_submit_value_register">
                                    </li>
                                </ul>
                            </form>
                        </transition>
                    </li>
                </ul>
            </li>
            <li>
                <transition name="fade">
                    <div v-if="show" id="logos" ref="logos">
                        <ul>
                            <li>
                                <ul>
                                    <li><img :src="$url + 'img/Logos_Sistema_FAEP.png'"></li>
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/1.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/1.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/1.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/2.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/2.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/2.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/3.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/3.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/3.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/4.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/4.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/4.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/5.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/5.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/5.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/6.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/6.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/6.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/7.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/7.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/7.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/8.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/8.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/8.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/9.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/9.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/9.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/10.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/10.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/10.webp'">
                                        </picture>
                                    </li>
                                    <li>
                                        <picture>
                                            <source :srcset="$url + 'img/home/11.webp'" type="image/webp">
                                            <source :srcset="$url + 'img/home/11.png'" type="image/png"> 
                                            <img :src="$url + 'img/home/11.webp'">
                                        </picture>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </transition>
            </li>
        </ul>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        name: "LoginComponent",
        computed: {
        },
        data() {
            return {
                btn_submit               : false,
                btn_submit_value         : 'ENTRAR',
                btn_submit_value_register: 'CADASTRAR',
                error                    : null,
                error_register           : null,
                errors                   : null,
                errors_register          : null,
                password_icon            : 'eye.webp',
                show                     : false
            }
        },
        methods: {
            block(v) {
                this.btn_submit_value = (v ? "Aguarde..." : "ENTRAR");
                this.btn_submit_value_register = (v ? "Aguarde..." : "CADASTRAR");
                this.$refs["btn-submit"].style.pointerEvents = (v ? 'none' : 'auto');
                this.$refs["btn-submit"].style.opacity = (v ? '.4' : '1');
            },
            passwordHandler(e) {
                if (this.password_icon === 'eye.webp') {
                    this.password_icon = 'no_eye.webp';
                    e.currentTarget.parentElement.getElementsByTagName('input')[0].type = 'text';
                } else {
                    this.password_icon = 'eye.webp';
                    e.currentTarget.parentElement.getElementsByTagName('input')[0].type = 'password';
                }
            },



            login(e) {
                this.error = null;
                if (this.$refs["name"].value.length < 2) {
                    this.error = 'O campo nome é obrigatório.';
                } else if (this.$refs["password"].value.length < 3) {
                    this.error = 'Mínimo de 3 letras para sua senha.';
                }
                if (this.error) {
                    e.preventDefault();
                } else {
                    this.sendLogin(e);
                }
            },
            sendLogin(e) {
                if (!this.submit) {
                    this.block(true);
                    let form_data = new FormData(this.$refs["login-form"]);
                    axios.get(this.$b + 'api/users/data?' + new URLSearchParams(form_data).toString()).then(response => this.loginResponse(response));
                }
                e.preventDefault();
            },
            loginResponse(obj) {
                if ((obj.data.success === true) && (obj.data.token)) {
                    let user = { token: obj.data.token, id: obj.data.id, email: obj.data.email, name: obj.data.name, points: obj.data.points, avatar:obj.data.avatar };
                    this.$parent.saveUser(user);
                    this.$router.push('/avatar');
                } else if (obj.data.errors) {
                    this.errors = obj.data.errors;
                }
                this.block(false);
            },


            register(e) {
                this.error_register = null;
                if (this.$refs["name_register"].value.length < 2) {
                    this.error_register = 'O campo nome é obrigatório.';
                } else if ((this.$refs["email"].value != "") && (!/^([A-Za-z0-9_\-.+])+@([A-Za-z0-9.])+\.([A-Za-z]{2,})$/.test(this.$refs["email"].value))) {
                    this.error_register = 'O campo "E-mail" deve ser um endereço de e-mail válido.';
                } else if (this.$refs["password_register"].value.length < 3) {
                    this.error_register = 'Mínimo de 3 letras para sua senha.';
                }

                if (this.error_register) {
                    e.preventDefault();
                } else {
                    this.sendRegister(e);
                }
            },
            sendRegister(e) {
                if (!this.submit) {
                    this.block(true);
                    let form_data = new FormData(this.$refs["register-form"]);
                    axios.post(this.$b + 'api/users', form_data).then(response => this.registerResponse(response));
                }
                e.preventDefault();
            },
            registerResponse(obj) {
                if ((obj.data.success === true) && (obj.data.token)) {
                    let user = { token: obj.data.token, id: obj.data.id, email: obj.data.email, name: obj.data.name, points: obj.data.points, avatar: obj.data.avatar };
                    this.$parent.saveUser(user);
                    this.$router.push('/avatar');
                } else if (obj.data.errors) {
                    this.errors_register = obj.data.errors;
                }
                this.block(false);
            }



        },
        mounted() {
            this.show = true;
        }
    }
</script>

<style scoped>

    #login
    {
        text-align: center;
        width: 100%;
    }
    #bg
    {
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
    }
    #login > ul > li
    {
        box-sizing: border-box;
        list-style: none;
        padding: 30px 0;
    }
    #login > ul > li > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        padding: 0 40px;
        vertical-align: top;
    }
    #login-form
    {
        position: relative;
        text-align: left;
        width: 400px;
    }
    #login-form > ul > li
    {
        box-sizing: border-box;
        display: block;
        padding: 10px;
    }
    



    /*----- register -----*/
    #register-form
    {
        position: relative;
        text-align: left;
        width: 400px;
    }
    #register-form > ul > li
    {
        box-sizing: border-box;
        display: block;
        padding: 5px 10px;
    }
    /*----- \register\ -----*/



    /*----- logos -----*/
    #logos
    {
        position: relative;
    }
    #logos > ul > li
    {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 20px;
        box-sizing: border-box;
        display: inline-block;
        height: 80px;
        margin-right: 5px;
        padding: 0 30px;
        vertical-align: top;
    }
    #logos > ul > li > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;       
    }
    #logos > ul > li > ul > li img
    {
        object-fit: contain;
        object-position: center;
        width: 80px;
        height: 80px;
    }
    /*----- \logos\ -----*/

    h3
    {
        box-sizing: border-box;
        color: #9fb327;
        font-family: 'Paper Cutout';
        font-size: 50px;
        font-weight: normal;
        padding: 0 15px;
    }
    h4
    {
        background-color: #2a623d;
        border-radius: 6px;
        box-sizing: border-box;
        color: #fff;
        display: inline;
        font-family: 'Roboto';
        font-size: 12px;
        padding: 10px 15px;
    }
    .box-0
    {
        background: rgb(255,255,255);
        background: -moz-linear-gradient(top, rgba(255,255,255,1) 40%, rgba(255,255,255,.5) 100%);
        background: -webkit-linear-gradient(top, rgba(255,255,255,1) 40%,rgba(255,255,255,.5) 100%);
        background: linear-gradient(to bottom, rgba(255,255,255,1) 40%,rgba(255,255,255,.5) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff',GradientType=0 );
        border: solid 3px #9fb327;
        border-radius: 14px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        display: block;
        padding: 10px 50px;
    }
    .icon-eye
    {
        box-sizing: border-box;
        cursor: pointer;
        float: right;
        margin: -54px 0 0 calc(100% - 44px);
        padding: 10px;
        position: relative;
    }




    .fade-enter-active, .fade-leave-active {
        top: calc(50% - 36px);
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 50%;
        opacity: 0;
    }


    @media screen and (max-width: 1100px)
    {
        #logos > ul > li
        {
            height: auto;
            margin-top: 5px;
            padding: 10px 0;
            text-align: center;
            width: calc(100% - 30px);
        }
        #logos > ul > li > ul > li
        {
            border-bottom: solid 1px #e5e5e5;
            display: block;
            margin: 0 auto;
            max-width: 220px;
        }
        #logos > ul > li > ul > li img
        {
            object-fit: none !important;
            width: auto !important;
            height: auto !important;
        }
    }
    @media screen and (max-width: 980px)
    {
        #login > ul > li > ul > li
        {
            padding: 0 10px;
            width: 100%;
        }
        
        #login-form, #register-form
        {
            width: calc(100%);
        }
        
    }
</style>